/**
 * text要素を返す
 */
export function getTextValue(obj) {
  return (obj === undefined ? "" : (obj.text !== undefined ? obj.text : obj));
}

/**
 * 通常運賃の金額を取得する
 */
export function getFareAndCharge(course) {
  var totalFare = 0;
  var totalCharge = 0;
  if (course.Ticket !== undefined) {
    var prices = course.Ticket.Price
    for (var i = 0; i < prices.length; i++) {
      if (prices[i].id == "normal") {
        totalFare += parseInt(prices[i].fareSummary)
        totalCharge += parseInt(prices[i].chargeSummary)
      }
    }
  }
  return { totalFare: totalFare, totalCharge: totalCharge };
}

/**
 * フリーパスの合計金額を取得する
 */
export function getFreePass(course) {
  var totalSet = {};
  if (course.Ticket !== undefined) {
    var prices = course.Ticket.Price
    for (var i = 0; i < prices.length; i++) {
      if (prices[i].id != "normal") {
        if (totalSet[prices[i].id] == undefined) totalSet[prices[i].id] = {}
        if (totalSet[prices[i].id]['name'] == undefined) totalSet[prices[i].id]['name'] = prices[i].Name
        if (totalSet[prices[i].id]['freePassPrice'] == undefined) totalSet[prices[i].id]['freePassPrice'] = parseInt(prices[i].freePassPrice)
        if (totalSet[prices[i].id]['otherPrice'] == undefined) totalSet[prices[i].id]['otherPrice'] = 0
        if (totalSet[prices[i].id]['available'] == undefined) {
          totalSet[prices[i].id]['available'] = prices[i].available
        } else if (!totalSet[prices[i].id]['available']) {
          totalSet[prices[i].id]['available'] = prices[i].available
        }
        if (totalSet[prices[i].id]['ticketLink'] == undefined) totalSet[prices[i].id]['ticketLink'] = prices[i].TicketLink
        totalSet[prices[i].id]['otherPrice'] += (parseInt(prices[i].fareSummary) + parseInt(prices[i].chargeSummary))
      }
    }
  }
  return totalSet;
}
